import React from 'react';
export class ErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main className="ci-loading" data-testid="page-error"><h1>Something didn’t open correctly.</h1><p>Your account and saved data are unchanged.</p><a href="/intelligence" data-testid="error-return-intelligence">Open Crescent Intelligence</a><a href="/" data-testid="error-return-home">Crescent Advisory Home</a></main>;
    return this.props.children;
  }
}